/**
 * Opens the shell's "New message" sheet (Slack's ⌘N), optionally prefilled with people — e.g. "Add people" on a DM,
 * which starts a new, larger conversation. The app shell provides it; without a provider it does nothing.
 */
import { createContext, useContext } from "react";

export type NewMessageApi = { openNewMessage: (prefill?: readonly string[]) => void };

export const NewMessageContext = createContext<NewMessageApi>({ openNewMessage: () => {} });

export function useNewMessageSheet(): NewMessageApi {
  return useContext(NewMessageContext);
}
